// IMPORT
    // MODULE(S)
        import React, { useState, useRef, useEffect } from 'react';
        import { v4 as uuidv4 } from 'uuid';
    // STYLE(S)
        import '../sass/Main.scss';
    // COMPONENT(S)
        import TodoList from './TodoList';
        import TodoForm from './TodoForm';
        import TodoRecap from './TodoRecap';



// EXTERNAL CONTENT
    // TOOL : useEffect => Info : To save and restore data after reloading the page
        const LOCAL_STORAGE_KEY = "todolist-app.list";



// MAIN CONTENT - FUNCTION / COMPONENT
    function Main() {


        // TOOL : useState => Info : To switch state and save the todos
            const [list, updateList] = useState([]);
            // const [list, updateList] = useState([{ id: 0, name: "Buy bread", complete: true }, { id: 1, name: "Go to the gym", complete: false }]);


        // TOOL : useRef => Info : To get fields value
            const ref_captcha = useRef();
            const ref_newTodo = useRef();


        // TOOL : useEffect => Info : To save and restore data after reloading the page
            useEffect(() => {
                const storedList = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
                if(storedList) { updateList(storedList); }
            }, []);
            useEffect(() => {
                localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(list));
            }, [list]);


        // FUNCTION(S)
            function handler_toggleTodo(id) {
                const newList = [...list];
                const todo = newList.find(todo => todo.id === id);
                todo.complete = !todo.complete;
                updateList(newList);
            };
            function handler_clearTodo(id) {
                const captcha = ref_captcha.current.value;
                if (captcha !== "") { return; }
                else {
                    const newList = list.filter(todo => todo.id !== id );
                    updateList(newList);
                }
            };
            function handler_modifyTodo(id, newName) {
                const captcha = ref_captcha.current.value;
                if (captcha !== "") { return; }
                else {
                    const newList = [...list];
                    const todo = newList.find(todo => todo.id === id);
                    todo.name = newName;
                    updateList(newList);
                }
            };
            function handler_addNewTodo() {
                const captcha = ref_captcha.current.value;
                if (captcha !== "") { return; }
                else {
                    const name = ref_newTodo.current.value;
                    ref_newTodo.current.value = null;
                    if (name === "") { return; }
                    else {
                        updateList(previousList => {
                            let id = uuidv4();
                            return [...previousList, { id: id, name: name, complete: false }];
                        })
                    }
                }
            };
            function handler_clearList() {
                const captcha = ref_captcha.current.value;
                if (captcha !== "") { return; }
                else {
                    const newList = list.filter(todo => !todo.complete);
                    updateList(newList);
                }
            };
            function handler_deleteList() {
                const captcha = ref_captcha.current.value;
                if (captcha !== "") { return; }
                else {
                    const newList = [];
                    updateList(newList);
                }
            };


        // RETURN
            return (
                <div className="main App-section">
                    <TodoList
                        list={list}
                        updateList={updateList}
                        toggleTodo={handler_toggleTodo}
                        clearTodo={handler_clearTodo}
                        modifyTodo={handler_modifyTodo} />
                    <TodoForm
                        captcha={ref_captcha}
                        newTodo={ref_newTodo}
                        addNewTodo={handler_addNewTodo}
                        clearList={handler_clearList}
                        deleteList={handler_deleteList} />
                    <TodoRecap
                        list={list} />
                </div>
            );
    }
    export default Main;
